export function scoreColor(score: number): string {
  if (score >= 4.5) return 'text-green-500'
  if (score >= 3.5) return 'text-emerald-600 dark:text-emerald-400'
  if (score >= 2.5) return 'text-amber-600 dark:text-amber-400'
  return 'text-destructive'
}

export function scoreBarColor(score: number): string {
  if (score >= 4.5) return 'bg-green-500'
  if (score >= 3.5) return 'bg-emerald-500'
  if (score >= 2.5) return 'bg-amber-500'
  return 'bg-destructive'
}
